@if (!carrouselItem.isAddMember) {
  <div class="btn carrousel-avatar-button" [class.carrousel-avatar-selected]="carrouselItem.isSelected">
    <span class="carrousel-avatar-image-border carrousel-avatar-border">
      <img class="carrousel-avatar-image-web" alt="{{ carrouselItem.avatarAlt }}" [src]="carrouselItem.avatarSrc" />
    </span>
    <span class="justify-content-center px-1">
      <ng-container [ngTemplateOutlet]="carrouselItem.whoUsesIt ? whoUsesIt : any"> </ng-container>

      <ng-template #whoUsesIt>
        <div
          class="carrousel-avatar-label"
          [attr.aria-label]="('details.who_uses_it.label' | translate) + ', ' + carrouselItem.offerItems[0].offerName"
        >
          <a [href]="carrouselItem.whoUsesItUrl | link" [attr.data-e2e]="e2e + carrouselItem.id">{{
            'details.who_uses_it.label' | translate
          }}</a>
        </div>
      </ng-template>

      <ng-template #any>
        @if (carrouselItem.type === 'member') {
          <div class="carrousel-avatar-label standard mb-0" aria-description=", vos/votre offres">
            <a
              [href]="carrouselItem.button.link | link"
              (click)="selectAvatar(carrouselItem); (false)"
              [attr.data-e2e]="e2e + carrouselItem.id"
              >{{ carrouselItem.button.label }}</a
            >
          </div>
        } @else {
          <h3 class="carrousel-avatar-label standard mb-0" aria-description=", vos/votre offres">
            {{ carrouselItem.button.label }}
          </h3>
        }
      </ng-template>
    </span>
  </div>
}

@if (carrouselItem.offerItems && carrouselItem.offerItems.length > 0) {
  <div class="justify-content-center mb-1">
    @for (contract of carrouselItem.offerItems; track contract; let index = $index) {
      <ecm-carrousel-nav
        [item]="contract"
        [index]="index"
        [carrouselItem]="carrouselItem"
        [selectedLink]="selectedLink"
        [carrouselLinksItemsSelected]="carrouselLinksItemsSelected"
        [isSosh]="isSosh"
      ></ecm-carrousel-nav>
    }
  </div>
}
